var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-week"},[_c('div',{staticClass:"items-week"},_vm._l((_vm.items),function(item,index){return _c('div',{staticClass:"item-week my-cursor",class:{
                'icon-option-true': _vm.week === index,
                'icon-option-false': _vm.week !== index,
             },on:{"click":function($event){$event.stopPropagation();return _vm.submit(index)}}},[_vm._v(_vm._s(item))])}),0),_c('div',{staticClass:"skip-state"},[_c('div',{staticClass:"text-skip"},[_vm._v("智能跳过法定节假日")]),_c('div',{staticClass:"my-cursor",class:{
            'icon-switch-false': !_vm.skipHolidaysState,
            'icon-switch-true': _vm.skipHolidaysState,
        },on:{"click":function($event){$event.stopPropagation();return _vm.saveSkipState.apply(null, arguments)}}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }